import { submitFetch } from '@/js/components/common';
import edjsHTML from "editorjs-html"
import Mustache from 'mustache';
import linkToolHtml from '@/js/components/plugins/editorjs/templates/link-tool.html';
import youtubeHtml from '@/js/components/plugins/editorjs/templates/embed-youtube.html';
import youtubeShortHtml from '@/js/components/plugins/editorjs/templates/embed-youtube-short.html';
import instagramHtml from '@/js/components/plugins/editorjs/templates/embed-instagram.html';
import xTwitterHtml from '@/js/components/plugins/editorjs/templates/embed-x-twitter.html';
import embedIframeHtml from '@/js/components/plugins/editorjs/templates/embed-iframe.html';
import shopInfoHtml from '@/js/components/plugins/editorjs/templates/shop-info.html';
import shopInfo from './plugins/editorjs/shop-info';

class ScriptExec {
    constructor() { }
    // evalを使うと警告が煩いので代替の関数
    eval2(obj) {
        if (obj == "") return;
        return Function("return (() => {" + obj + "})()")();
    }

    // 他ファイルのjsを実行する関数
    evalFromFile(path) {
        const xhr = new XMLHttpRequest();

        xhr.open("GET", path, true);
        xhr.onreadystatechange = (() => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                this.eval2(xhr.responseText);
            }
        });
        xhr.send();
    }

    // HTMLCollectionからscript要素を見つけ出して実行する関数
    evalFromHTMLCollection(htmlCollection) {
        for (let i = 0; i < htmlCollection.length; i++) {
            const element = htmlCollection.item(i);

            if (element.nodeName == "SCRIPT") { // script要素なら関連のjsを実行
                // srcが指定されている場合は、そのファイルのjsも実行
                if (element.src != null && element.src != "") this.evalFromFile(element.src);
                // テキストノードのjsを実行
                this.eval2(element.textContent);
            } else { // script要素以外なら子要素にscript要素が無いか検索
                //this.evalFromHTMLCollection(element.children);
            }
        }
    }
}

const imgPreloadCheck = (url) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            if (img.width < img.height) {
                resolve('vertical')
            }
            resolve('horizontal')
        }
    });
}

const getUrlByKey = async (key) => {
    const res = await submitFetch(`/file/url`, 'GET', { key });
    if ('error' in res) {
        return ''
    }
    return res.url
}

const linkButtonBlock = (block) => {
    const typeClass = {
        1: 'black',
        2: 'white'
    }
    let targetAttr = ''
    if (block.data.target) {
        targetAttr = `target="${block.data.target}"`
    }
    return `<a class="link-button ${typeClass[block.data.type]}" href="${block.data.url}" ${targetAttr}>${block.data.name}</a>`;
}

const linkToolBlock = (block) => {
    return Mustache.render(linkToolHtml, {
        ...block.data,
    });
}

const shopInfoBlock = (block) => {
    submitFetch(`/api/shoplist/${block.data.shop_id}`)
        .then(resp => {
            const targetList = document.querySelectorAll(`.shop-info[data-shop-id="${resp.data.id}"`)
            targetList.forEach((target) => {
                if (target.classList.contains('is-loaded')) return;
                target.innerHTML = Mustache.render(shopInfoHtml, {
                    ...resp.data,
                });
                target.classList.add('is-loaded');
            });
        });
    return `<div class="shop-info" data-shop-id="${block.data.shop_id}"></div>`;
}

const enbedBlock = (block) => {
    let template = null
    switch (block.data.service) {
        case 'youtube':
            template = youtubeHtml
            break
        case 'youtubeShort':
            template = youtubeShortHtml
            break
        case 'instagram':
            template = instagramHtml
            break
        case 'twitter':
            template = xTwitterHtml
            break
        default:
            template = embedIframeHtml
    }
    return Mustache.render(template, {
        ...block.data,
    });
}

export const createToc = (targetSelector) => {
    const contentEl = document.querySelector(targetSelector)

    if (contentEl.querySelectorAll('h2').length) {
        const tocEl = document.createElement('nav')
        tocEl.id = 'toc'
        tocEl.innerHTML = '<ul></ul>'
        contentEl.parentNode.insertBefore(tocEl, contentEl);

        contentEl.querySelectorAll('h2').forEach((el, i) => {
            el.id = `toc-${i}`
            const li = document.createElement('li')
            li.innerHTML = `<a href="#toc-${i}">${el.innerText}</a>`
            document.querySelector('#toc ul').appendChild(li)
        })
    }
}

const imageBlock = (block) => {
    const figClassList = []
    const imgClassList = []
    if (block.data.withBorder) {
        figClassList.push('ejs-border')
    }
    if (block.data.withBackground) {
        figClassList.push('ejs-background')
    }
    if (block.data.stretched) {
        imgClassList.push('ejs-stretched')
    }

    return `
    <figure class="image ${figClassList.join(' ')}">
        <div class="image-wrap">
            <img src="${block.data.file.url}" alt="${block.data.caption}" class="${imgClassList.join(' ')}" />
        </div>
    ${block.data.caption ? `<figcaption>${block.data.caption}</figcaption>` : ''}
    </figure>`;
}

const rawBlock = (block) => {
    return block.data.html
}

const getContent = async (type, id, column, secure = false) => {
    const res = await submitFetch(`/api/edjs/${type}/${id}`, 'GET', { column, secure })
    const edjsParser = edjsHTML({
        image: imageBlock,
        linkButton: linkButtonBlock,
        linkTool: linkToolBlock,
        embed: enbedBlock,
        shopInfo: shopInfoBlock,
        raw: rawBlock,
    })
    if (!res.content) return '';
    res.content.blocks = await Promise.all(res.content.blocks.map(async (_val) => {
        return new Promise(async (resolve) => {
            if (_val.type === 'image') {
                _val.data.file.url = await getUrlByKey(_val.data.file.key)
                console.log(_val.data.file.url)
            }
            resolve(_val);
        })
    }));

    return edjsParser.parse(res.content).join('')
}

export const loadEdjsContent = async (type, id, column, targetSelector, secure = false) => {
    const content = await getContent(type, id, column, secure)
    document.querySelector(targetSelector).innerHTML = content
    document.querySelector(targetSelector).classList.add('is-loaded');

    document.querySelectorAll(`${targetSelector} figure.image img`).forEach((img) => {
        imgPreloadCheck(img.src).then((res) => {
            img.classList.add(res)
        });
    });

    document.querySelectorAll('.embed-iframe').forEach((el) => {
        const iframe = el.querySelector('iframe')
        iframe.contentWindow.addEventListener('DOMContentLoaded', function () {
            const height = iframe.contentDocument.body.clientHeight;
            console.log(height)
        });
        el.querySelector('.iframe').style.aspectRatio = `${iframe.width}/${iframe.height}`
    })

    // 埋め込みHTML内のscriptタグを実行
    const scriptExec = new ScriptExec();
    scriptExec.evalFromHTMLCollection(document.querySelector(targetSelector).children);
    if (window.instgrm) {
        window.instgrm.Embeds.process();
    }
    return content
}
